import LazyLoad from "vanilla-lazyload";
import _Vue from "vue"

class LazyLoader {
  public install(Vue: typeof _Vue) {
    Vue.prototype.$lazyLoad = (container?: HTMLElement) => {
      return new LazyLoad({
        container: container,
        class_error: "lazy-error",
      });
    }
  }
}

export default new LazyLoader() ;
